import {
    Button,
    makeStyles,
    TextField,
    Typography,
    IconButton,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
    member as v_member,
    basic,
    Values,
    SNACKBAR_TIME,
    member,
} from '../request/values';

import React, { Fragment, useState } from 'react';
import { COLORS } from './Theme';

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';
import { SIcon } from './Icon';
import CheckIcon from '@material-ui/icons/Check';

import useFixedButtonStyles from './commonStyles/headerEmpty/useFixedButtonStyles';
import useCommonStyles from './commonStyles/headerEmpty/useCommonStyles';

const useStyles = makeStyles((theme) => ({
    nanumSquare_regular: {
        fontFamily: 'NanumR',
    },
    submit: {
        height: 60,
        color: `${COLORS.WATER_BLUE}`,
        textColor: '#ffffff',
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        '&:hover': {
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
    },
    animation: {
        width: '5vw',
        borderWidth: 3,
        borderColor: `${COLORS.SLATE_GREY}`,
        fontSize: 0,
        borderLeftColor: `${COLORS.WATER_BLUE}`,
        animation: 'rotating 2s 0.25s linear infinite',
        '&:after': {
            content: '',
        },
    },
    testBtn: {
        height: 60,
        color: `${COLORS.WATER_BLUE}`,
        textColor: '#ffffff',
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        '&:hover': {
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
        '&:after': {
            content: '이메일 인증 요청하기',
        },
    },
    cardContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        marginTop: '5vh',
        marginBottom: '2vh',
        height: '22vh',
        overflowY: 'auto',
        '& #idCard': {
            width: '80%',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            border: '1px solid lightgray',
            borderRadius: '5px',
            padding: '20px',
            fontWeight: 'bold',
        },
    },
    buttonContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        '& #button': {
            flex: 1,
            height: 60,
            color: 'white',
            fontWeight: 'bold',
            margin: theme.spacing(3, 0, 2),
            borderRadius: '10px',
            boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
            border: 'solid 0.5px #cfd4d9',
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
    },
}));

const SERVER = basic.server;

interface iUserId {
    member_email: string;
    join_date: string;
}

const FindId: React.FC<any> = (props) => {
    const classes = useStyles();
    const fixedButtonClasses = useFixedButtonStyles();
    const commonClasses = useCommonStyles();
    const { enqueueSnackbar } = useSnackbar();
    let history = useHistory();

    const [memberName, setMemberName] = useState<string>('');
    const [idInfo, setIdInfo] = useState<iUserId[] | null>(null);

    const buttonText = ['ID 검색하기'];

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        if (id === 'member_name') {
            setMemberName(value);
        }
    };

    const getAuth = () => {
        let url = new URL(SERVER + v_member.member + v_member.auth_id_info);
        let params = { name: memberName };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log(data.list);
                if (data.code == Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.AUTH_ID_SUCCSESS_STR, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    //setAuth((prevState) => true);
                    setIdInfo(data.list);
                } else if (data.code == Values.FAIL_CODE) {
                    // this is success == dont exist same id
                    enqueueSnackbar(ToastStr.AUTH_ID_FAIL_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME * 2,
                        translate: 'no',
                    });
                }
            });
    };

    const movePage = (page: string) => {
        if (page === 'pwd') {
            history.push({
                pathname: '/findPassword',
            });
        } else if (page === 'login') {
            history.push({
                pathname: '/',
            });
        }
    };

    const handleButton = (e: any) => {
        if (memberName.length == 0) {
            enqueueSnackbar(ToastStr.NAME_ET_CHECK_STR, {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
                translate: 'no',
            });
        } else {
            getAuth();
        }
    };

    return (
        <div>
            <div className={fixedButtonClasses.fixedButton}>
                <IconButton onClick={() => history.goBack()}>
                    <SIcon type="Back" />
                </IconButton>
            </div>
            <div className={commonClasses.paper}>
                <div className={commonClasses.titleLeft}>
                    아이디 검색을 위해
                    <br />
                    이름을 입력해주세요.
                </div>
                {idInfo === null ? (
                    <div className={commonClasses.form}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="member_name"
                            label="가입한 이름을 입력하세요."
                            name="name"
                            autoComplete="name"
                            //autoFocus
                            InputProps={{ className: commonClasses.inputProps }}
                            InputLabelProps={{
                                className: commonClasses.inputLabel,
                            }}
                            value={memberName}
                            onChange={valueChangeHandler}
                            style={{ color: `${COLORS.CHARCOAL_GREY}` }}
                        />
                        <div style={{ color: `${COLORS.DOWN}` }}>
                            * 해당 날짜에 가입한 아이디만 검색할 수 있습니다.
                        </div>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            className={classes.submit}
                            onClick={handleButton}
                        >
                            <Typography variant="h3">
                                {buttonText[0]}
                            </Typography>
                        </Button>
                    </div>
                ) : (
                    <div>
                        <div className={classes.cardContainer}>
                            {idInfo.map((info, index) => (
                                <div id="idCard" key={index}>
                                    <div>{'아이디: ' + info.member_email}</div>
                                    <div>
                                        {info.join_date
                                            .split(' ')[1]
                                            .slice(0, 5)}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className={classes.buttonContainer}>
                            <Button
                                id="button"
                                onClick={() => {
                                    movePage('pwd');
                                }}
                            >
                                <div>비밀번호 변경하기</div>
                            </Button>
                            <Button
                                id="button"
                                onClick={() => {
                                    movePage('login');
                                }}
                            >
                                <div>로그인하기</div>
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FindId;
